import { firebaseDb } from '../../config/firebaseConfig'

function getPeriodicity(startDate, endDate) {
  const days = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab']
  if (startDate === null || endDate === null) {
    return days
  }
  const newStart = new Date(startDate)
  const newEnd = new Date(endDate)
  const difDays = newEnd.getTime() - newStart.getTime()

  const totalDays = (difDays / (1000 * 3600 * 24)).toFixed(0)

  if (totalDays > 6) {
    return days
  } else {
    const firstDay = newStart.getDay()
    const lastDay = newEnd.getDay()
    if (firstDay > lastDay) {
      const end = days.slice(0, lastDay + 1)
      const start = days.slice(firstDay)
      const newDays = [...end, ...start]
      return newDays
    } else if (firstDay < lastDay) {
      const newDays = days.slice(firstDay, lastDay + 1)
      return newDays
    } else {
      return [days[firstDay]]
    }
  }
}

function getAllExperiences(location, category, startDate, endDate) {
  const periodicity = getPeriodicity(startDate, endDate)

  if (location !== 'ALL' && category === 'ALL') {
    return firebaseDb
      .collectionGroup('experiences')
      .where('locator', '==', location)
      .where('isActive', '==', true)
      .where('periodicity', 'array-contains-any', periodicity)
      .get()
      .then((querySnapshot) => {
        const data = []
        querySnapshot.forEach((doc) => {
          const experience = doc.data()
          const agencyKey = getAgencyKey(doc.ref.path)
          data.push({ ...experience, agencyKey })
        })
        return data
      })
      .catch((err) => {
        console.log(err)
      })
  } else if (category !== 'ALL' && location === 'ALL') {
    return firebaseDb
      .collectionGroup('experiences')
      .where('category', '==', category)
      .where('isActive', '==', true)
      .where('periodicity', 'array-contains-any', periodicity)
      .get()
      .then((querySnapshot) => {
        const data = []
        querySnapshot.forEach((doc) => {
          const experience = doc.data()
          const agencyKey = getAgencyKey(doc.ref.path)
          data.push({ ...experience, agencyKey })
        })
        return data
      })
      .catch((err) => {
        console.log(err)
      })
  } else if (
    location !== '' &&
    category !== '' &&
    location !== 'ALL' &&
    category !== 'ALL'
  ) {
    return firebaseDb
      .collectionGroup('experiences')
      .where('locator', '==', location)
      .where('category', '==', category)
      .where('isActive', '==', true)
      .where('periodicity', 'array-contains-any', periodicity)
      .get()
      .then((querySnapshot) => {
        const data = []
        querySnapshot.forEach((doc) => {
          const experience = doc.data()
          const agencyKey = getAgencyKey(doc.ref.path)
          data.push({ ...experience, agencyKey })
        })
        return data
      })
      .catch((err) => {
        console.log(err)
      })
  } else if (location === 'ALL' && category === 'ALL') {
    return firebaseDb
      .collectionGroup('experiences')
      .where('isActive', '==', true)
      .where('periodicity', 'array-contains-any', periodicity)
      .get()
      .then((querySnapshot) => {
        const data = []
        querySnapshot.forEach((doc) => {
          const experience = doc.data()
          const agencyKey = getAgencyKey(doc.ref.path)
          data.push({ ...experience, agencyKey })
        })
        return data
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

async function getAllExperiencesByMarketplaceFilter(
  agencyId,
  agencyName,
  location,
  category,
  startDate,
  endDate,
) {
  //  const periodicity = getPeriodicity(startDate, endDate)

  try {
    if (location !== 'ALL' && category === 'ALL') {
      const experiencesResponse = await firebaseDb
        .collection(`agency/${agencyId}/experiences`)
        .where('locator', '==', location)
        .where('isActive', '==', true)
        //   .where('periodicity', 'array-contains-any', periodicity)
        .get()

      const data = []
      experiencesResponse.forEach((doc) =>
        data.push({ ...doc.data(), agencyKey: agencyId, agencyName }),
      )

      return data
    }

    if (category !== 'ALL' && location === 'ALL') {
      const experiencesResponse = await firebaseDb
        .collection(`agency/${agencyId}/experiences`)
        .where('category', '==', category)
        .where('isActive', '==', true)
        //   .where('periodicity', 'array-contains-any', periodicity)
        .get()

      const data = []
      experiencesResponse.forEach((doc) =>
        data.push({ ...doc.data(), agencyKey: agencyId, agencyName }),
      )

      return data
    }

    if (
      location !== '' &&
      category !== '' &&
      location !== 'ALL' &&
      category !== 'ALL'
    ) {
      const experiencesResponse = await firebaseDb
        .collection(`agency/${agencyId}/experiences`)
        .where('locator', '==', location)
        .where('category', '==', category)
        .where('isActive', '==', true)
        //    .where('periodicity', 'array-contains-any', periodicity)
        .get()

      const data = []
      experiencesResponse.forEach((doc) =>
        data.push({ ...doc.data(), agencyKey: agencyId, agencyName }),
      )

      return data
    }

    if (location === 'ALL' && category === 'ALL') {
      const experiencesResponse = await firebaseDb
        .collection(`agency/${agencyId}/experiences`)
        .where('isActive', '==', true)
        //  .where('periodicity', 'array-contains-any', periodicity)
        .get()

      const data = []
      experiencesResponse.forEach((doc) =>
        data.push({ ...doc.data(), agencyKey: agencyId, agencyName }),
      )

      return data
    }
  } catch (error) {
    console.log(error)
  }
}

function getExperienceById(experienceId) {
  return firebaseDb
    .collectionGroup('experiences')
    .where('key', '==', experienceId)
    .get()
    .then((querySnapshot) => {
      let data = {}
      querySnapshot.forEach((doc) => {
        const experience = doc.data()
        const agencyKey = getAgencyKey(doc.ref.path)
        data = { ...experience, agencyKey }
      })
      return data
    })
}

function getExperienceBySlug(agencyId, slug) {
  return firebaseDb
    .collection(`agency/${agencyId}/experiences`)
    .where('seo.slug', '==', slug)
    .get()
    .then((querySnapshot) => {
      let data = {}
      querySnapshot.forEach((doc) => {
        const experience = doc.data()
        data = { ...experience, agencyKey: agencyId }
      })
      return data
    })
}

function getNameExperienceSettings(agencyId, experienceId) {
  return firebaseDb
    .collection(`agency/${agencyId}/settings`)
    .get()
    .then((querySnapshot) => {
      let data = []
      querySnapshot.docs.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() })
      })

      const found = data.find((product) => {
        return product.experiences.some((item) => {
          return item.key === experienceId && item.checked === true
        })
      })

      return found
    })
}

function getAgencyKey(path) {
  return path.split('/')[1]
}

function getExperiencesByAgency(agencyId, agencyName) {
  return firebaseDb
    .collection(`/agency/${agencyId}/experiences`)
    .where('isActive', '==', true)
    .get()
    .then((querySnapshot) => {
      const data = []
      querySnapshot.forEach((doc) => {
        const experience = doc.data()
        const agencyKey = getAgencyKey(doc.ref.path)
        data.push({ ...experience, agencyKey, agencyName })
      })
      return data
    })
}

function getExperienceGallery(agencyId, experienceId) {
  return firebaseDb
    .collection('agency')
    .doc(agencyId)
    .collection('experiences')
    .doc(experienceId)
    .collection('gallery')
    .get()
    .then((querySnapshot) => {
      let data = []
      querySnapshot.forEach((doc) => {
        data.push(doc.data().image)
      })
      return data
    })
    .catch((err) => {
      console.log(err)
    })
}

function getScheduleExperience(agencyId, experienceId) {
  return firebaseDb
    .collection(`agency/${agencyId}/experiences/${experienceId}/schedule`)
    .get()
    .then((querySnapshot) => {
      let data = {}
      querySnapshot.forEach((doc) => (data = { ...doc.data() }))
      return data
    })
}

async function getResources(agencyId, experienceId) {
  return firebaseDb
    .collection(`agency/${agencyId}/resources`)
    .get()
    .then((querySnapshot) => {
      const resources = []
      querySnapshot.forEach((res) => {
        const data = res.data()
        const ifExist = data.experiences.findIndex(
          (exp) => exp.key === experienceId,
        )
        if (ifExist !== -1) {
          resources.push({ ...data, key: res.id })
        }
      })
      return resources
    })
}

async function getResourcesAvailability(resource, agencyId, experienceId) {
  const availability = []
  let isAvailable = true
  const ref = await firebaseDb
    .collection(`agency/${agencyId}/resources/${resource.key}/availability`)
    .get()
  if (ref.empty) {
    isAvailable = false
  } else {
    ref.forEach((av) => {
      availability.push({ ...av.data(), key: av.id })
    })
  }
  return JSON.stringify({ isAvailable, availability })
}

function getScheduleExperienceCollection(agencyId, experienceId) {
  return firebaseDb.collection(
    `agency/${agencyId}/experiences/${experienceId}/schedule`,
  )
}

function getExperienceByUrl(agencyId, experienceName) {
  return firebaseDb
    .collection(`agency/${agencyId}/experiences`)
    .where('name', '==', experienceName)
    .get()
    .then((querySnapshot) => {
      let data = {}
      querySnapshot.forEach((doc) => (data = { ...doc.data() }))
      return data
    })
}

function getExperienceReviews(agencyId, experienceId, limit) {
  return firebaseDb
    .collection(`agency/${agencyId}/experiences/${experienceId}/reviews`)
    .limit(limit && limit)
    .orderBy('createdAt', 'desc')
    .get()
    .then((querySnapshot) => {
      let data = []
      querySnapshot.forEach((doc) => data.push(doc.data()))

      return data
    })
}

function createExperienceReview(agencyId, experienceId, review) {
  return firebaseDb
    .collection(`/agency/${agencyId}/experiences/${experienceId}/reviews`)
    .add(review)
    .then((res) => {
      const reviewDoc = firebaseDb.doc(
        `/agency/${agencyId}/experiences/${experienceId}/reviews/${res.id}`,
      )

      review.key = res.id
      reviewDoc.update(review)
    })
    .catch((err) => {
      console.log(err)
      return false
    })
}

function getAllExperiencesReviews(agencyId) {
  return firebaseDb
    .collectionGroup('reviews')
    .where('agencyKey', '==', agencyId)
    .orderBy('createdAt', 'desc')
    .get()
    .then((querySnapshot) => {
      const data = []
      querySnapshot.forEach((doc) => {
        const experience = doc.data()
        const agencyKey = getAgencyKey(doc.ref.path)
        data.push({ ...experience, agencyKey })
      })
      return data
    })
}

const getExperienceRoomIds = async (agencyId, experienceId) => {
  try {
    const experienceResponse = await firebaseDb
      .doc(`/agency/${agencyId}/experiences/${experienceId}`)
      .get();

    return experienceResponse.data().channelRoomId;
  } catch (err) {
    return { error: err };
  }
};

export {
  getAllExperiences,
  getExperienceById,
  getExperiencesByAgency,
  getExperienceGallery,
  getScheduleExperience,
  getExperienceByUrl,
  getScheduleExperienceCollection,
  getExperienceReviews,
  createExperienceReview,
  getAllExperiencesReviews,
  getAllExperiencesByMarketplaceFilter,
  getExperienceBySlug,
  getResources,
  getResourcesAvailability,
  getNameExperienceSettings,
  getExperienceRoomIds
}
